import { attr, BaseModel } from "../../lib/itn-ui-kit/data";

export default class CaseUserStatModel extends BaseModel {
  static urlPath = "case/user_stats";

  @attr("json") caseStatusCounts;
  @attr("json") medicalStatusCounts;
  @attr("array") roleCounts;
  @attr("number") totalCases;
  @attr("number") withRoleAssignmentCount;
  @attr("number") withoutRoleAssignmentCount;
}